module.exports = __webpack_public_path__ + "static/media/villa.c430e404.svg";